import { defineStore } from 'pinia'
import api from '@/api'

const ERROR_MAP = {
  'User not found': 'login.errors.userNotFound',
  'Invalid credentials': 'login.errors.invalidCredentials',
  'Use Google Sign-In for this account': 'login.errors.googleRequired',
  'Email and password are required': 'login.errors.missingFields',
  'Missing idToken': 'login.errors.missingFields',
  'Login failed': 'login.errors.default',
  'Invalid Google Token': 'login.errors.invalidGoogle',
  'Token missing': 'login.errors.tokenMissing',
  'Invalid token': 'login.errors.tokenInvalid',
  'Token revoked or expired': 'login.errors.tokenRevoked',
}

function mapError(raw) {
  if (!raw) return 'login.errors.default'
  return ERROR_MAP[raw] || 'login.errors.default'
}

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: null,
    token: localStorage.getItem('dashboard_token') || null,
    isLoading: false,
    error: null
  }),

  getters: {
    isAuthenticated: (state) => !!state.token
  },

  actions: {
    async loginWithEmail(email, password) {
      this.isLoading = true
      this.error = null
      try {
        const response = await api.post('/api/dashboard/auth/login', { email, password })
        this.token = response.data.token
        this.user = response.data.user
        localStorage.setItem('dashboard_token', response.data.token)
        if (response.data.user?.licenseType) {
          localStorage.setItem('dashboard_license', response.data.user.licenseType)
        }
        api.defaults.headers.common['Authorization'] = `Bearer ${response.data.token}`
        return { success: true }
      } catch (error) {
        this.error = mapError(error.response?.data?.error)
        return { success: false, error: this.error }
      } finally {
        this.isLoading = false
      }
    },

    async loginWithGoogle(idToken) {
      this.isLoading = true
      this.error = null
      try {
        const response = await api.post('/api/dashboard/auth/google', { idToken })
        this.token = response.data.token
        this.user = response.data.user
        localStorage.setItem('dashboard_token', response.data.token)
        if (response.data.user?.licenseType) {
          localStorage.setItem('dashboard_license', response.data.user.licenseType)
        }
        api.defaults.headers.common['Authorization'] = `Bearer ${response.data.token}`
        return { success: true }
      } catch (error) {
        this.error = mapError(error.response?.data?.error)
        return { success: false, error: this.error }
      } finally {
        this.isLoading = false
      }
    },

    logout() {
      this.user = null
      this.token = null
      this.error = null
      localStorage.removeItem('dashboard_token')
      localStorage.removeItem('dashboard_license')
      delete api.defaults.headers.common['Authorization']
    },

    initAuth() {
      const token = localStorage.getItem('dashboard_token')
      if (token) {
        this.token = token
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`
      }
    }
  }
})
